export default {"src":"/_next/static/media/buy-again.3e659d24.svg","height":12,"width":12};